<template>
  <div class="table-container">
    <el-table :data="wordcloudData" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA', color: '#333' }">
      <el-table-column prop="name" label="技术概念词"> </el-table-column>
      <el-table-column prop="value" label="论文数量"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    wordcloudData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.table-container {
  margin-top: 10px;
}
</style>
